<template>
	<div>
		<nav class="nav-tabs">
			<ul>
				<li :class="[activeTabName === tab.name ? 'active ' + tab.name : tab.name]" v-for="tab in tabs" v-if="!tab.disabled">
					<span v-if="tab.disabled"><i :class="tab.icon"></i>{{ tab.displayName }}</span>
					<a @click.prevent="setActiveTabName(tab.name)" v-if="!tab.disabled"><i :class="tab.icon"></i> {{ tab.displayName }}</a>
				</li>
			</ul>
		</nav>
		<div class="main">
			<settings-homepage
					v-if="activeTabName === 'settingsHomepage'">
			</settings-homepage>
			<settings-hub-pages
					v-if="activeTabName === 'settingsHubPages'">
			</settings-hub-pages>
			<settings-providers
					v-if="activeTabName === 'settingsProviders'">
			</settings-providers>
			<settings-about-us
					v-if="activeTabName === 'settingsAboutUs'">
			</settings-about-us>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tabs: [
					{
						name: 'settingsHomepage',
						displayName: 'Homepage',
						icon: 'fas fa-home',
						disabled: false
					},
					{
						name: 'settingsHubPages',
						displayName: 'Hub Pages',
						icon: 'fas fa-project-diagram',
						disabled: false
					},
					{
						name: 'settingsProviders',
						displayName: 'Providers',
						icon: 'far fa-id-card',
						disabled: true
					},
					{
						name: 'settingsAboutUs',
						displayName: 'About Us page',
						icon: 'fas fa-users',
						disabled: false
					},
				],
				activeTabName: null,
			}
		},
		created() {
			let url_string = window.location.href;
			let url = new URL(url_string);
			this.activeTabName = url.searchParams.get("tab");
		},
		mounted() {
			this.activeTabName = this.activeTabName ? this.activeTabName : this.tabs[0].name;
		},
		methods: {
			setActiveTabName: function (name) {
				this.activeTabName = name;
				window.history.replaceState('', '', this.updateURLParameter(window.location.href, 'tab', name));
			},
			updateURLParameter: function (url, param, paramVal) {
				let newAdditionalURL = "";
				let tempArray = url.split("?");
				let baseURL = tempArray[0];
				let additionalURL = tempArray[1];
				let temp = "";
				if (additionalURL) {
					tempArray = additionalURL.split("&");
					for (var i = 0; i < tempArray.length; i++) {
						if (tempArray[i].split('=')[0] != param) {
							newAdditionalURL += temp + tempArray[i];
							temp = "&";
						}
					}
				}

				let rows_txt = temp + "" + param + "=" + paramVal;
				return baseURL + "?" + newAdditionalURL + rows_txt;
			}
		}
	}
</script>
